import React, { useState } from 'react';

const items = [
  { name: 'About Us', path: '/about' },
  { name: 'Our Patron', path: '/our-patron' },
  { name: 'Aims And Objectives', path: '/aims-objectives' },
  { name: 'Prayers', path: '/prayers' },
  { name: 'CBSE Website', path: 'https://www.cbse.gov.in/', external: true },
  { name: 'Subjects Of Examination', path: '/subject-examination' },
  { name: 'Syllabus', path: '/syllabus' },
  { name: 'Co-Curricular Activities', path: '/co-curricular' },
  { name: 'Examinations And Promotions', path: '/examination-promotion' },
  { name: 'Procedure For Withdrawal', path: '/withdrawal' },
  { name: 'Helps to Study', path: '/help-study' },
  { name: 'TC', path: '/Tc' },
  { name: 'Book List', path: 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/pdf/Book_list.pdf', external: true },
  { name: 'Campus Information', path: '/campus-information' },
  { name: 'General Information', path: '/general-information' },
  { name: 'School Information', path: '/school-information' },
  { name: 'Rules of Discipline', path: '/dicipline' },
  { name: 'Rules for Payment of Fee', path: '/payment-fee' },
  { name: 'Admission Regulations', path: '/admission-regulations' },
  { name: 'Leave Rules', path: '/leave-rules' },
  { name: 'School Uniform', path: '/uniform' },
  { name: 'School Library', path: '/library' },
  { name: 'School Hours', path: '/school-hour' },
  { name: 'Managing Committee', path: '/managing-committee' },
  { name: 'Our Managers', path: '/our-managers' },
  { name: 'Our Principals', path: '/our-principals' },
  { name: 'Student Cabinets', path: '/student-cabinets' },
  { name: 'School Staff', path: '/school-staff' },
  { name: 'School Management', path: '/school-management' },
  { name: "Chairman’s Message", path: '/chairman' },
  { name: "Manager’s Message", path: '/manager' },
  { name: "Principal’s Message", path: '/principal' },
  { name: "Headmistress’s Message", path: '/headmistress' },
  { name: "President’s Message", path: '/president-message' },
  { name: 'Photo Gallery', path: '/gallery' },
  { name: 'Video Gallery', path: '/VideoGallery' },
  { name: 'Magazine', path: '/Magazine' },
  { name: 'Voice Message', path: '/voice-message' },
  { name: 'Contact Us', path: '/contact-us' },
];

function Search() {
  const [showInput, setShowInput] = useState(false);
  const [query, setQuery] = useState('');

  const toggleInput = () => {
    setShowInput(prev => !prev);
    setQuery('');
  };

  const filteredItems =
    query.trim() === ''
      ? []
      : items.filter(item =>
        item.name.toLowerCase().includes(query.toLowerCase())
      );

  const handleClick = (item) => {
    if (item.external) {
      // Open external links in new tab
      window.open(item.path, '_blank', 'noopener,noreferrer');
    } else {
      // Navigate internally by changing path
      window.location.pathname = item.path;
    }
    setShowInput(false);
    setQuery('');
  };

  return (
    <div className="search-container">
      <button onClick={toggleInput} className="search-toggle-btn">
        <i className="bi bi-search"></i>
      </button>

      {showInput && (
        <div className="search-dropdown">
          <input
            type="text"
            placeholder="Search..."
            autoFocus
            value={query}
            onChange={e => setQuery(e.target.value)}
            className="search-input"
          />

          {query.trim() !== '' && (
            <ul className="search-results">
              {filteredItems.length > 0 ? (
                filteredItems.map(item => (
                  <li
                    key={item.path}
                    className="search-result-item"
                    onClick={() => handleClick(item)}
                    style={{ cursor: 'pointer' }}
                  >
                    {item.name}
                  </li>
                ))
              ) : (
                <li className="no-results">No results found</li>
              )}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}

export default Search;
